import { render, staticRenderFns } from "./NewVehicleViolation.vue?vue&type=template&id=567cf592&"
import script from "./NewVehicleViolation.vue?vue&type=script&lang=ts&"
export * from "./NewVehicleViolation.vue?vue&type=script&lang=ts&"
import style0 from "./NewVehicleViolation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports